module.exports = __webpack_public_path__ + "img/6-supervalue-assist-personal-details.7bbafe83.jpg";